import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getNotebook(title: string, fetch: Fetch) {
  return fetch(`/notebook/${title}`, { method: 'get' }, schemas.NotebookDto);
}

export const useGetNotebookQuery = (title?: string) => {
  return useQuery({
    queryKey: ['notebook', title],
    retry: false,
    enabled: !!title,
    networkMode: 'online',
    queryFn: async () => {
      if (!title) {
        return;
      }
      const notebook = await getNotebook(title, fetch);
      console.log(notebook);
      return notebook;
    }
  });
};
